//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
import uniNumberBox from "@/components/uni-number-box/uni-number-box.vue"
import calendarPage from '@/components/calendarPage/calendarpage.vue'
import moreContent from '@/components/more-content/index.vue'
import commentList from '@/components/commentList/index.vue'
import collect from '@/components/collect/index.vue'
import uniRate from "@/components/uni-rate/uni-rate.vue"
export default {
	data() {
		return {
			//swiper轮播图
			indicatorDots: true, //是否显示面板指示点
			circular: true, //是否采用衔接滑动
			autoplay: true, //是否自动切换
			interval: 3000, //自动切换时间间隔
			duration: 500, //滑动动画时长
			current: 1, //当前所在滑块
			currentLength: 0, //图片总数
			imgList: [], //轮播图数组
			//基础内容和头部价格与时间
			id: '',
			salePrice: 0, //成人价格
			childPrice: 0, //儿童价格
			saleNum: 1,
			childrenNum: 0,
			stock: 0,
			isSellingChild: '',
			noUse: true,
			detail: {},
			// 评论相关
			commentObj: {
			  total: 0,
			  starLevel: 5
			},
			showCommentList:false,
			collect: {
				collectionType: '20',
				productGroupType: '1005',
				collectionId: '',
			},
			headerDateList: {
				saleSettlementPrice: '',
				childSettlementPrice: '',
				date: ''
			},
			//日历
			dateList: {
				info: {
					checkInDate: '2018-7-2',
					checkOutDate: '2018-7-3'
				},
				startText: '',
				pattern: 'single',
				range: [],
				show: false,
				close: false
			},
		}
	},
	components: {
		calendarPage,
		moreContent,
		commentList,
		collect,
		uniRate,
		uniNumberBox
	},
	computed: {
		saleStock() {
			let usedStock = this.childrenNum
			let residue = this.stock - usedStock
			let saleStock = residue <= 0 ? 0 : residue
			return saleStock
		},
		childStock() {
			let usedStock = this.saleNum
			let residue = this.stock - usedStock
			let childStock = residue <= 0 ? 0 : residue
			return childStock
		},
		totlePrice() {
			return parseFloat(this.salePrice * this.saleNum + this.childPrice * this.childrenNum).toFixed(2)
		}
	},
	async onLoad(event) {
		this.collect.collectionId = this.id = event.id
		await this.queryDetail()
	},
	methods: {
		updateComments(data) {
		  this.commentObj.total = data.count
		  this.commentObj.starLevel = parseFloat(data.dataObj || 0)
		},
		activeDay(val){
			this.salePrice = val.date.saleSettlementPrice
			this.childPrice = val.date.childSettlementPrice
		},
		//成人数量
		saleChange(val) {
			this.saleNum = val
		},
		//儿童数量
		childrenChange(val) {
			this.childrenNum = val
		},
		//获取线路详情
		queryDetail() {
			this.$ajax({
				method: 'post',
				url: '/weChat/lineOrder/queryProductByProductId',
				data: {
					productId: this.id
				}
			}).then(res => {
				this.detail = res.data
				this.imgList = res.data.images.split(',')
				this.currentLength = this.imgList.length
				if (this.detail.productName.length >= 40) {
					this.detail.productName = this.detail.productName.slice(0, 40)
				}
				this.advanceDay()
				this.selectDate()




			})
		},
		jump() {
			uni.navigateTo({
				url: '/pages/common/images?image=' + this.imgList
			})
		},
		//顶部轮播图当前图片页数
		changeImg(event) {
			this.current = event.detail.current + 1
		},
		//获取提前预订时间
		advanceDay() {
			if (this.detail.advanceTime !== '') {
				let detailAdvanceTime = this.detail.advanceTime.split(':')
				let time = {
					day: moment().add(this.detail.advanceDays, 'days').format('DD'),
					hour: detailAdvanceTime[0],
					minute: detailAdvanceTime[1],
					second: detailAdvanceTime[2]
				}
				let advanceTime = moment({
					day: time.day,
					hour: time.hour,
					minute: time.minute,
					second: time.second
				}).format('YYYY-MM-DD HH:mm:ss')
				let advanceDays = moment().add(this.detail.advanceDays, 'days').format('YYYY-MM-DD HH:mm:ss')
				this.advanceDate = new Date(advanceTime.replace(/-/gm, '/')) > new Date(advanceDays.replace(/-/gm, '/')) ? this.detail
					.advanceDays : this.detail.advanceDays + 1
			} else {
				this.advanceDate = this.detail.advanceDays
			}
		},
		// 根据日期获取线路价格与事件
		queryWeChatLineData(date) {
			if (date !== undefined) {
				this.dateList.info.checkInDate = moment(new Date(date.checkInDate.replace(/-/gm, '/'))).format('YYYY-M-D')
			}
			this.$ajax({
				method: 'post',
				url: '/weChat/lineOrder/queryDayStateByDateRange',
				data: {
					productId: this.id,
					productTypeCode: this.detail.productTypeCode,
					beginDate: date === undefined ? moment().add(this.advanceDate, 'days').format('YYYY-MM-DD') : moment(new Date(
						date.checkInDate.replace(/-/gm, '/'))).format('YYYY-MM-DD'),
					endDate: date === undefined ? moment().add(this.advanceDate, 'days').format('YYYY-MM-DD') : moment(new Date(
						date.checkInDate.replace(/-/gm, '/'))).format('YYYY-MM-DD')
				}
			}).then(res => {
				if (res.data.data.length !== 0) {
					this.headerDateList = res.data.data[0]
					this.clickDate = this.headerDateList.date
				}
				this.dateList.close = true
				setTimeout(() => {
					this.dateList.show = false
				}, 300)
			})
		},
		// 日期范围获取
		selectDate() {
			let beginDate = new Date()
			let endDate = beginDate.setMonth(beginDate.getMonth() + 12)
			this.$ajax({
				method: 'post',
				url: '/weChat/lineOrder/queryDayStateByDateRange',
				data: {
					productId: this.id,
					productTypeCode: this.detail.productTypeCode,
					beginDate: moment().add(this.advanceDate, 'days').format('YYYY-MM-DD'),
					endDate: moment(endDate).format('YYYY-MM-DD')
				}
			}).then(res => {
				if (res.data.data.length !== 0) {
					this.noUse = false
					this.salePrice = res.data.data[0].saleSettlementPrice
					this.childPrice = res.data.data[0].childSettlementPrice
					this.stock = res.data.data[0].stock
					this.isSellingChild = res.data.isSellingChild
					this.headerDateList = res.data.data[0]
					this.dateList.range = res.data.data
					this.dateList.info.checkInDate = res.data.data[0].date
					this.dateList.info.defaultOpenDate = this.dateList.info.checkInDate
					this.headerDate = true
				}
			})
		},
		//预订
		toOrder() {
			if (!this.noUse) {
				if (this.dateList.range.length > 0 && !this.headerDate) {
					this.handleTimeClick()
				} else {
					uni.navigateTo({
						url: `/pages/route/order?id=${this.id}&date=${this.headerDateList.date}&productTypeCode=${this.detail.productTypeCode}&saleNum=${this.saleNum}&childrenNum=${this.childrenNum}`
					})
				}
			}
		},
		// 弹出日历弹框
		handleTimeClick() {
			if (this.dateList.range.length > 0) {
				this.dateList.close = false
				this.dateList.show = true
			} else {
				this.dateList.show = false
				this.dateList.close = false
			}
		},
		// 日历关闭
		handelClose() {
			this.dateList.close = true
			setTimeout(() => {
				this.dateList.show = false
			}, 300)
		}
	}
}
